export default {"src":"/login-app/[GIT_HASH]/_next/static/media/lineage_depth.212c34ee.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};